import { render, staticRenderFns } from "./NewPatientReport.vue?vue&type=template&id=23457ece&scoped=true"
import script from "./NewPatientReport.vue?vue&type=script&lang=js"
export * from "./NewPatientReport.vue?vue&type=script&lang=js"
import style0 from "./HuddleComponentsModern.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./NewPatientReport.vue?vue&type=style&index=1&id=23457ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23457ece",
  null
  
)

export default component.exports